import React from 'react'
import Loading from '../components/Loading'


const MapViewFallBack = (props) => {
  return (
     <div className="map">
        <Loading/>
     </div>
  )
}

export default MapViewFallBack
